import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../axios_instance';
import axios from 'axios';
import { BaseUrlAuth } from '../../utils';

const Home: React.FC = () => {
  const isAdmin = useRef<string>();
  const history = useNavigate();
  useEffect(() => {
    axios
      .get(BaseUrlAuth + '/api/v1/users/me', {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('jwt_token'),
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      })
      .then((response) => {
        isAdmin.current = response.data.is_admin;
        if (isAdmin.current === '1') {
          history('/admin');
        } else {
          history('/user');
        }
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .catch((error) => {
        history('/signin');
      });
  }, []);

  return <></>;
};

export default Home;
